/**
 * Remounts a route element when one of its URL params changes.
 *
 * React Router keeps the same element mounted when only a param changes, so a
 * route whose hooks hold per-property state (an upload in flight, a draft
 * correction, a chosen leimikko) would carry it into the next property. A
 * sealed route renders exactly one archetype and cannot key itself, so the
 * route table keys it here instead.
 */
import React from 'react';
import { useParams } from 'react-router-dom';

export function RouteParamKeyed({
  param,
  element,
}: {
  param: string;
  element: React.ReactElement;
}): React.ReactElement {
  const params = useParams();
  return <React.Fragment key={params[param] ?? ''}>{element}</React.Fragment>;
}
